import IDataCenter from '@/interfaces/dataCenter/IDataCenter';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
    name: 'DataCenterForm'
})
export default class DataCenterForm extends Vue {
    @Prop(Object) private dataCenterData!: IDataCenter;
    @Prop(Boolean) private isEdit!: boolean;

    private get form():IDataCenter {
        return this.dataCenterData;
    }

    private get isCreateForm() {
        return this.$route.name === 'data_center_create';
    }

    private get btnText() {
        return this.isCreateForm ? 'Create' : 'Update';
    }

    private sendForm() {
        const formData = {
            id: this.form.id,
            name: this.form.name
        };
        this.isCreateForm ? this.$emit('createDataCenter', formData) : this.$emit('updateDataCenter', formData)
    }


    private cancelForm() {
        this.$router.go(-1);
    }
}
